// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admission-documents {
  height: calc(100vh - 110px) !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.admission-documents .content {
  margin: 0 10px;
}
.admission-documents .documents-list {
  font-size: 12px;
  font-weight: 500;
  color: #494949;
  margin-top: 5px;
}
.admission-documents .loading {
  position: absolute;
  top: 0;
  left: 361px;
  width: calc(100% - 370px);
  height: 100%;
  background: rgb(255, 255, 255);
  z-index: 1;
}
.admission-documents .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
  display: flex;
  align-items: center;
}
.admission-documents .icon svg {
  fill: white;
  width: 100%;
}
.admission-documents a {
  color: #4e5857;
}
.admission-documents a:hover > div {
  background: rgba(0, 0, 0, 0.05);
}
.admission-documents .box-error {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.25);
}
.admission-documents .employeeImg {
  width: 50px;
  height: 50px;
}
.admission-documents .text-blue {
  color: #40c2ff;
}
.admission-documents .description {
  margin: 0 10px;
}
.admission-documents .button-blue {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  border: none;
  border-radius: 50rem;
  padding: 0 10px;
  color: white;
}
.admission-documents .btnDelete {
  background-color: #EC6376;
  color: white;
}
.admission-documents .empty-template {
  background-color: #f8f4fc;
  color: #8F95B2;
}

.modal-documents {
  max-width: 950px;
  min-width: 800px;
}
.modal-documents .button-save {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  border: none;
  border-radius: 50rem;
  padding: 0 20px;
  color: white;
  height: 35px;
  width: 100%;
}

.custom-dropdown-button {
  background-color: white;
  border: none;
  box-shadow: none;
  color: black;
}
.custom-dropdown-button .dropdown-toggle::after {
  content: none;
}
.custom-dropdown-button:hover {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

.custom-list-group .list-group-item.active {
  background-color: blue;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Views/Documents/AdmissionDocuments.sass"],"names":[],"mappings":"AAAA;EACI,sCAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;AACR;AACI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACR;AAEI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AADR;AAGI;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AADR;AAGQ;EACI,WAAA;EACA,WAAA;AADZ;AAGI;EACI,cAAA;AADR;AAGQ;EACI,+BAAA;AADZ;AAGI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AADR;AAGI;EACI,WAAA;EACA,YAAA;AADR;AAGI;EACI,cAAA;AADR;AAGI;EACI,cAAA;AADR;AAGI;EACI,4DAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;AADR;AAKI;EACI,yBAAA;EACA,YAAA;AAHR;AAKI;EACI,yBAAA;EACA,cAAA;AAHR;;AAKA;EACI,gBAAA;EACA,gBAAA;AAFJ;AAII;EACI,4DAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAFR;;AAKA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAIE;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;AAFJ;;AAKA;EACE,sBAAA;EACA,YAAA;AAFF","sourcesContent":[".admission-documents\n    height: calc(100vh - 110px) !important\n    overflow-y: scroll\n    overflow-x: hidden\n    \n    .content\n        margin: 0 10px\n\n    .documents-list\n        font-size: 12px\n        font-weight: 500\n        color: #494949\n        margin-top: 5px\n\n\n    & .loading\n        position: absolute\n        top: 0\n        left: 361px\n\n        width: calc(100% - 370px)\n        height: 100%\n        background: rgba(255,255,255,1)\n        z-index: 1\n\n    & .icon\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        padding: 8px\n        margin: 0 10px\n        display: flex\n        align-items: center\n\n        & svg\n            fill: white\n            width: 100%\n\n    & a\n        color: #4e5857\n\n        &:hover > div\n            background: rgba(0,0,0,.05)\n\n    & .box-error\n        margin: 15px 0\n        display: flex\n        justify-content: center\n        align-items: center\n        font-weight: bold\n        color: rgba(0,0,0,.25)\n\n    .employeeImg\n        width: 50px\n        height: 50px\n\n    .text-blue\n        color: #40c2ff\n\n    .description\n        margin: 0 10px\n\n    .button-blue\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        border: none\n        border-radius: 50rem\n        padding: 0 10px\n        color: white\n        // height: 35px\n        // width: 70%\n    \n    .btnDelete\n        background-color: #EC6376\n        color: white\n    \n    .empty-template\n        background-color: #f8f4fc\n        color: #8F95B2\n\n.modal-documents\n    max-width: 950px\n    min-width: 800px\n\n    .button-save\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        border: none\n        border-radius: 50rem\n        padding: 0 20px\n        color: white\n        height: 35px\n        width: 100%\n\n// Estilos para o botão do dropdown\n.custom-dropdown-button\n  background-color: white\n  border: none\n  box-shadow: none\n  color: black\n\n  .dropdown-toggle::after \n    content: none\n        \n  &:hover\n    background-color: transparent\n    border: none\n    box-shadow: none\n\n// Estilos para o item ativo do ListGroup\n.custom-list-group .list-group-item.active \n  background-color: blue\n  color: white\n\n\n       \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
